import React from "react";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import close_modal from "./../../../assets/ic_close_wh.svg";
import moment from "moment";
import { useEffect, useState } from "react";
import find from "lodash/find";
import { Button } from "../../../common/Button/Button";
import DatePicker from "react-datepicker";
import api from "../../../utils/api";
import Select from "react-select";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import ReactDatePicker from "react-datepicker";
import Checkbox from "../../../common/Checkbox/Checkbox";
import { getServiceTypesMaster } from "../../../utils/localStorage";
import { URL_CALCULATOR } from "../../../utils/urls";
import { Info } from "react-feather";
import { DND_LINK } from "../../../utils/constants";
import { NavButtons } from "../../../common/NavButtons/NavButtons";
import { ChevronLeft, ChevronRight, User } from "react-feather";
import Spinner from "../../../common/Spinner/Spinner";
import MyServiceRequestStatusProgression from "./MyServiceRequestStatusProgression";
import SelectCatalogueModal from "./SelectCatalogueModal";
import NeftModal from "./NeftModal";
import { toast } from "react-toastify";
import axios from "axios";
import copysvg from "../../../assets/arrow_copy_light.svg"
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function MyServiceRequestsDetailsModal({
    serviceRequestReadOnlyData,
    serviceRequestEditableData,
    ...props
}) {
    const getServiceName = (code) => {
        if (!code) return;
        const found = find(getServiceTypesMaster(), { sServiceCode: code });
        if (found) {
            return found.sServiceName;
        }
        return "";
    };

    var CurrentDate = new Date().toLocaleDateString('en-CA')
    let timeRN = moment(new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }),'hh:mm A').format('HH:mm')

    const copyToClipboard = (content) => {
		const el = document.createElement('textarea');
		el.value = content;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

    const [ltExpert, setLTExpert] = useState()
    const [expert, setExpert] = useState('')
    const [state, setState] = useState('')
    const [slotData, setSlotData] = useState()
    const [showName, setShowName] = useState('')
    const [isTrue, setIsTrue] = useState(false)
    const [outerAssign, setOuterAssign]= useState(false)
    const [newModal, setNewModal] = useState(false)
    const [infoModal, setInfoModal] = useState(false)
    const [updatePriceModal, setUpdatePriceModal] = useState(false)
    const [ExpertPartner, setExpertPartner] = useState()
    const [ExpertInfo, setExpertInfo] = useState()
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [data, setData] = useState()
    const [startDate, setStartDate] = useState(new Date());
    const [id, setId] = useState()
    const [updatedAmount, setUpdatedAmount] = useState('')
    const [isPriceUpdated, setIsPriceUpdated] = useState(false)
    const [confirmUpdatePriceModal, setConfirmUpdatePriceModal] = useState(false)

    const [loadingPriceModal, setLoadingPriceModal] = useState(false)

    const openConfirmUpdateModalisTrue = () => {
		setConfirmUpdatePriceModal(true)
	}

	const openConfirmUpdateModalisFalse = () => {
		setConfirmUpdatePriceModal(false)
	}


    const ResourceId = serviceRequestReadOnlyData.nResourceInstanceId
    let ExpertName
    {
        expert ?  ExpertName = expert : ExpertName = serviceRequestReadOnlyData.refExternalServicePartner
    }

    useEffect(() => {
        console.log("ReadData", serviceRequestReadOnlyData)
        LTExpertList()
        ExpertDeTails()
    },[serviceRequestReadOnlyData])

    useEffect(() => {
        ExpertAppointmentData()
    },[])

    useEffect(() => {
        // getDatabyID()
        ExpertCalenderData()
        if (ExpertPartner) {
            ExpertPartner.filter((ele) => ((ele.refExternalServicePartner === ExpertName) ? setId(ele.refExternalServicePartner_id) : ""))
            console.log("useEffectID", id)
        }
        setTimeout(() => {
            if (id) {
                // axios.get(`https://stagewebadmin.deasra.in:8050/server/get-expert-calender/${id}/`, {
                //     headers: {
                //         Authorization: "Token 11c2e5f0fc3aa6e71c5c5fc5211bd3ce692829a3"
                //     }
                // })
                api.getExpertById(id)
                    .then((res) => {
                        // alert(res.data)
                        setData(res.data)
                    })
            }
        }, 500);
    }, [id])

    let ExpertID = ""

    if (ExpertPartner) {
        console.log("POuter", ExpertPartner)
        ExpertPartner.filter((ele) => ((ele.refExternalServicePartner === ExpertName) ? ExpertID = ele.refExternalServicePartner_id : ""))
    }

    console.log("AAAA", ExpertID)

    const getDatabyID = () => {
        setId(ExpertID)
        //     // let ExpertName = localStorage.getItem("Resource")
        //     // let newID = ""
        //     if(ExpertPartner){
        //         // console.log("POuter", ExpertPartner)
        //        ExpertPartner.filter((ele) => ((ele.refExternalServicePartner === ExpertName) ? setId(ele.refExternalServicePartner_id): ""))   
        //     }
        // //     console.log("FROM OUTER FUNCTION", id)
        //     if(id){
        //     axios.get(`https://stagewebadmin.deasra.in:8050/server/get-expert-calender/${id}/`, {headers: {
        //         Authorization : "Token 11c2e5f0fc3aa6e71c5c5fc5211bd3ce692829a3"
        //     }}).then((res) => {
        //         // alert(res.data)
        //         setData(res.data)
        //     })
        // }
    }

    const ExpertAppointmentData = () => {
        api.getAllExpertAppointmentList().then(({data}) => {
            console.log("Appointments",data)
            setSlotData(data.reverse())
        })
    }

    let AppData = [];
    let MainData;
    let bookTime;

    if(slotData){
        MainData = slotData.filter((ele) => ele.bookdate >= new Date().toLocaleDateString('en-CA'))
        AppData = MainData.find((ele) => ele.nResourceInstanceId === ResourceId)
        
    }

    if(AppData != undefined && AppData.status === null){
        let newTime = AppData.slot_time.split("-")
        let newTime1 = newTime[0]
        let ampm = newTime[1].split(" ")[1]
        let result = `${newTime1} ${ampm}`
        if(result === "11:00 PM"){
            bookTime = "11:00"
        } else {
            bookTime = moment(result, 'hh:mm A').format('HH:mm')
        }
        
        console.log("Booktime",bookTime)
    }
    // console.log("AppoDTat",AppData.id)

    const deleteAppointment = () => {
        if(AppData != undefined && AppData.status === null){
            console.log("ID+++",AppData.id)
            let payload ={
                id:AppData.id
            }
            api.deleteExpertAppointment(payload)
            .then(({data}) => {
                ExpertAppointmentData()
                setPayloadDate("");
                setExpertTime("")
                console.log("Deleted",data)
                if(data === "Appointment Deleted Successfully."){
                    toast("Appointment Deleted Successfully.", {
                        type: toast.TYPE.SUCCESS
                    })
                }
            })
        }
    }

    const updatePriceButton = () => {
        if (updatedAmount && Number(updatedAmount) > 0) {
            setLoadingPriceModal(true)
            let payload = {
                nResourceInstanceId: ResourceId,
                fAmountFull: Number(updatedAmount)
            }
            api.updatePriceApi(payload)
                .then(({ data }) => {
                    toast("Price Updated Successfully.", {
                        type: toast.TYPE.SUCCESS,
                    });
                    props.handleClickPackage([serviceRequestReadOnlyData]);
                    setLoadingPriceModal(false)
                    // api.sendPaymentLink({
                    //     nResourceInstanceId: ResourceId
                    // }).then(() => {
                    //     toast("Sent Payment Link", {
                    //         type: toast.TYPE.SUCCESS,
                    //     });
                    // })
                    // props.onSendPaymentLink()
                    openPriceUpdateModalisFalse()
                    setUpdatedAmount('')
                    // props.getMyServiceRequests(true)
                    props.getMyServiceRequests()
                    props.handleServiceRequestClick(ResourceId)
                    // props.getMyServiceRequestsForInterval(true)
                    // props.handleServiceRequestClick(serviceRequestReadOnlyData)
                    setIsPriceUpdated(true)
                })
        } else if (updatedAmount && Number(updatedAmount) === 0) {
            if(serviceRequestReadOnlyData.sPackageOfferTitle === "Long Term Engagement Package"){
                toast("Price Cannot be Zero", {
                    type: toast.TYPE.ERROR,
                });
            } else {
                openConfirmUpdateModalisTrue()
            }
        } else {
            toast("Please Input Price", {
                type: toast.TYPE.ERROR,
            });
        }
    }

    const confirmUpdateModalClick = () => {
        openConfirmUpdateModalisFalse()
        setLoadingPriceModal(true)
        let payload = {
            nResourceInstanceId: ResourceId,
            fAmountFull: Number(updatedAmount)
        }
        api.updatePriceApi(payload)
            .then(({ data }) => {
                toast("Price Updated Successfully.", {
                    type: toast.TYPE.SUCCESS,
                });
                props.handleClickPackage([serviceRequestReadOnlyData]);
                setLoadingPriceModal(false)
                props.getMyServiceRequests()
                openPriceUpdateModalisFalse()
                setUpdatedAmount('')
                setIsPriceUpdated(true)
            })
    }


    console.log("Slot==", state)

    const dayNum = startDate.getDay()
    let day;
    if (dayNum === 0) {
        day = "Sunday"
    } else if (dayNum === 1) {
        day = "Monday"
    } else if (dayNum === 2) {
        day = "Tuesday"
    } else if (dayNum === 3) {
        day = "Wednesday"
    } else if (dayNum === 4) {
        day = "Thursday"
    } else if (dayNum === 5) {
        day = "Friday"
    } else {
        day = "Saturday"
    }

    const [commentsText, setCommentsText] = useState("")
    const [payloadDate, setPayloadDate] = useState("")

    const [expertTime, setExpertTime] = useState("")
    useEffect(() => {
        console.log('ExpertTime==', expertTime)
    },[expertTime])

    const [expertDay, setExpertDay] = useState("")
    console.log('ExpertDAy==', expertDay)


    let timeSlot = [];

    if (data) {
        console.log("GK==", data)
        data.filter((ele) => (ele.day === day) ? timeSlot.push(ele.time) : "");
    }


    const bookExpert = () => {
        if (expertTime === "") {
            toast("Expert Not Available for the Following Slot.", {
                type: toast.TYPE.ERROR,
            });
        } else {
            let payload;
            let CurrentDate = new Date()
            var getYear = CurrentDate.toLocaleString("default", { year: "numeric" });
            var getMonth = CurrentDate.toLocaleString("default", { month: "2-digit" });
            var getDay = CurrentDate.toLocaleString("default", { day: "2-digit" });
            var CurrDate1 = getYear + "-" + getMonth + "-" + getDay;
            if (payloadDate) {
                payload = {
                    nResourceInstanceId: ResourceId,
                    comments: commentsText,
                    expert_id: ExpertID,
                    slot_time: expertTime,
                    slot_day: day,
                    bookdate: payloadDate
                }
            } else {
                payload = {
                    nResourceInstanceId: ResourceId,
                    comments: commentsText,
                    expert_id: ExpertID,
                    slot_time: expertTime,
                    slot_day: day,
                    bookdate: CurrDate1
                }
            }

            api.bookExpertAppointment(payload).then(res => {
                setExpertTime("")
                // setExpertDay('')
                // setCommentsText('')
                // setStartDate(new Date())


                if (res.data.message === "Expert Appointment Updated Successfully.") {
                    toast("Expert Appointment Updated Successfully.", {
                        type: toast.TYPE.SUCCESS,
                    });
                    setTimeout(() => {
                        setModalIsOpenToFalse()
                    }, 1000)
                    setExpertTime('')
                    setExpertDay('')
                    setCommentsText('')
                    setStartDate(new Date())
                    localStorage.removeItem("Resource")
                    ExpertAppointmentData()
                } else {
                    toast("Appointment slot is unavailable .", {
                        type: toast.TYPE.ERROR,
                    });
                }
            })
        }
    }



    const ExpertCalenderData = () => {
        api.getAllExpertCalenderList().then(({ data }) => {
            console.log("Data", data)
            setExpertPartner(data)
        })
    }

    const ExpertDeTails = () => {
        let payload = {
            api_key: "82mqEyJnct4kzC8y"
            // api_key: "r54B?rHXUE7v%$9t"
        }
        api.getExpertInfo(payload).then(({ data }) => {
            console.log("InfoExpert", data.data)
            setExpertInfo(data.data)
        })
    }

    const columns = [
        {
            id: "expert_name",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'borderRight': 'solid 1px #ccc' },
            Header: "Expert Name",
            accessor: "expert_name",
            style: { 'whiteSpace': 'unset' },
            width: 400,
        },
        {
            id: "Xpert Cliniq (One-on-one single session)",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'borderRight': 'solid 1px #ccc' },
            Header: "Xpert Cliniq (One-on-one single session)",
            accessor: "Xpert Cliniq (One-on-one single session)",
            style: { 'whiteSpace': 'unset' },
            // width: 200,
        },
        {
            id: "Xpert Coaching (Long-term Engagement)",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'borderRight': 'solid 1px #ccc' },
            Header: "Xpert Coaching (Long-term Engagement)",
            accessor: "Xpert Coaching (Long-term Engagement)",
            style: { 'whiteSpace': 'unset' },
            // width: 200,
        },
        {
            id: "Xpert Consultation (One-on-one Package)",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'borderRight': 'solid 1px #ccc' },
            Header: "Xpert Consultation (One-on-one Package)",
            accessor: "Xpert Consultation (One-on-one Package)",
            style: { 'whiteSpace': 'unset' },
            // width: 200,
        },
    ]


    const expertColumns = [
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
            Header: "Expert Names",
            accessor: "refExternalServicePartner",
            style: { 'whiteSpace': 'unset' },
            // width: 100,
        },
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Monday",
            accessor: "calender_slots",
            Cell: ({ original }) => (
                <>
                    <span>
                        {
                            original.calender_slots.map((ele) => {
                                {
                                    return ele.day === "Monday" ? <div> {ele.time} </div> : ""
                                }
                                // return ele.day 



                            }
                            )
                        }</span>
                    {/* <span>{original["calen"]}</span> */}
                </>
            )
        },
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Tuesday",
            accessor: "calender_slots",
            Cell: ({ original }) => (
                <>
                    <span>
                        {
                            original.calender_slots.map((ele) => {
                                {
                                    return ele.day === "Tuesday" ? <div> {ele.time} </div> : ""

                                }
                                // return ele.day 



                            }
                            )
                        }</span>
                    {/* <span>{original["calen"]}</span> */}
                </>
            )
        },
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Wednesday",
            accessor: "calender_slots",
            Cell: ({ original }) => (
                <>
                    <span>
                        {
                            (original.calender_slots.reverse()).map((ele) => {
                                // let a = []
                                // a.push(ele.time)
                                // console.log("NEWWWWW",a)
                                return ele.day === "Wednesday" ? <div> {ele.time} </div> : ""
                            }
                            )
                        }</span>


                </>
            )
        },
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Thursday",
            accessor: "calender_slots",
            Cell: ({ original }) => (
                <>
                    <span>
                        {
                            original.calender_slots.map((ele) => {
                                {
                                    return ele.day === "Thursday" ? <div> {ele.time} </div> : ""

                                }
                                // return ele.day 



                            }
                            )
                        }</span>
                    {/* <span>{original["calen"]}</span> */}
                </>
            )
        },
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Friday",
            accessor: "calender_slots",
            Cell: ({ original }) => (
                <>
                    <span>
                        {
                            original.calender_slots.map((ele) => {
                                {
                                    return ele.day === "Friday" ? <div> {ele.time} </div> : ""

                                }
                                // return ele.day 



                            }
                            )
                        }</span>
                    {/* <span>{original["calen"]}</span> */}
                </>
            )
        },
        // {
        //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
        //     style: { 'whiteSpace': 'unset' },
        //     Header: "Tuesday",
        //     accessor: "calender_slots",
        // },
        // {
        //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
        //     style: { 'whiteSpace': 'unset' },
        //     Header: "Wednesday",
        //     accessor: "calender_slots.day",
        // },
        // {
        //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
        //     style: { 'whiteSpace': 'unset' },
        //     Header: "Thursday",
        //     accessor: "calender_slots.time",
        // },
        // {
        //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
        //     style: { 'whiteSpace': 'unset' },
        //     Header: "Friday",
        //     accessor: "calender_slots.time",
        // },
        // {
        //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '10%' },
        //     style: { 'whiteSpace': 'unset' },
        //     Header: "Slots Available",
        //     accessor: "time",
        // }

    ]


    const openCalenderModalIsTrue = () => {
        setNewModal(true)
        ExpertCalenderData()
    }

    const openCalenderModalIsFalse = () => {
        setNewModal(false)
    }

    const openInfoModalisTrue = () => {
        setInfoModal(true)
    }

    const openInfoModalisFalse = () => {
        setInfoModal(false)
    }

    const setModalIsOpenToTrue = () => {
        setModalIsOpen(true)
    }

    const setModalIsOpenToFalse = () => {
        setModalIsOpen(false)
    }

    const openPriceUpdateModalisTrue = () => {
        setUpdatePriceModal(true)
    }

    const openPriceUpdateModalisFalse = () => {
        setUpdatePriceModal(false)
        setUpdatedAmount('')
    }



    useEffect(() => {
        LTExpertList()
        ExpertDeTails()
    }, [serviceRequestReadOnlyData])

    console.log("ReadOnly", serviceRequestReadOnlyData)

    const LTExpertList = () => {
        // {
        //     serviceRequestReadOnlyData.sServiceCode === "LTEXP" ? 
        //     api.LTExpServicePartners().then(({ data }) => {
        //         setLTExpert(data)
    
        //     }) 
        //     : 
        //     serviceRequestReadOnlyData.sServiceCode === "LTEXPCOACH" ? 
        //     api.LTExpCoachServicePartners().then(({ data }) => {
        //         setLTExpert(data)
    
        //     })
        //     :
        //     serviceRequestReadOnlyData.sServiceCode === "EXPRTCONSULT"?
        //     api.ExpConsultServicePartners().then(({ data }) => {
        //         setLTExpert(data)
    
        //     })
        //     :
        //     ""
        // }
        if(serviceRequestReadOnlyData.sServiceCode === "LTEXP"){
            api.LTExpServicePartners().then(({ data }) => {
                        setLTExpert(data)
            
                    }) 
        }else if (serviceRequestReadOnlyData.sServiceCode === "LTEXPCOACH"){
            api.LTExpCoachServicePartners().then(({ data }) => {
                        setLTExpert(data)
            
                    })
        } else if(serviceRequestReadOnlyData.sServiceCode === "EXPRTCONSULT"){
            api.ExpConsultServicePartners().then(({ data }) => {
                        setLTExpert(data)
            
                    })
        } else if(serviceRequestReadOnlyData.sServiceCode === "GRPEXPRTCONSULT"){
            api.GRPExpConsultServicePartners().then(({ data }) => {
                setLTExpert(data)
    
            })
        }
        

    }

    // console.log("MYDATA==",setLTExpert)

    console.log("ExpertNAme==", expert)
    let Experts = []
    let ExpID = ''

    if (ltExpert) {
        ltExpert.filter((ele) => {
            if (ele.sName === expert) {
                ExpID = ele.id
            }
        })
    }

    console.log("Hey", ExpID)

    if (ltExpert) {
        ltExpert.map((ele) => {
            Experts.push(ele.sName)
        })
    }

    console.log("Experts=", Experts)

    // console.log("Experts==", Experts)

    // ltExpert.map((ele) => {
    //     console.log("DIff", ele.sName)
    // })
    // console.log("NEWDATA", ltExpert)



    const getDirection = (direction) => {
        {
            props.onNavigationButtonClick(direction);
        }
    };


    const getSelectedItem = (Options, value) => {

        // console.log("hdgsdsdsds")
        // console.log(Options);
        if (!Options) return null;
        let found = find(Options, {
            value: value,
        });
        if (found) {
            return found;
        }
        return null;
    };

    const SaveExpert1 = () => {
        let payload = {
            nResourceInstanceId: serviceRequestReadOnlyData.nResourceInstanceId,
            refExternalServicePartner: ExpID,
        }
        // axios.post("https://stagewebadmin.deasra.in:8050/server/service-request/update_externalservicepartner_id/", payload, {headers: {
        //     Authorization : "Token 11c2e5f0fc3aa6e71c5c5fc5211bd3ce692829a3"
        // }})
        api.updateExternalServicePartner(payload)
            .then((res) => {
                console.log(res.data.refExternalServicePartner)
                props.getMyServiceRequests()
                setShowName(expert)
                if(AppData != undefined && AppData.status === null){
                    console.log("ID+++",AppData.id)
                    let payload ={
                        id:AppData.id
                    }
                    api.deleteExpertAppointment(payload)
                    .then(({data}) => {
                        console.log("Deleted",data)
                        if(data === "Appointment Deleted Successfully."){
                            toast("Appointment Deleted Successfully.", {
                                type: toast.TYPE.SUCCESS
                            })
                        }
                    })
                }
            })
        // api.saveServicePartner(payload).then((res) => {
        //     console.log("SHOWMENAME",res.data.refExternalServicePartner)
        //     setShowName(res.data.refExternalServicePartner)
        // })
        toast("Expert Assigned.", {
            type: toast.TYPE.SUCCESS,
        })
        props.handleServiceRequestClick(serviceRequestReadOnlyData.nResourceInstanceId)
        
        setIsTrue(true)

        // setTimeout(() => {
        //     window.location.reload()
        // }, 3000);
    }

    const SaveExpert = () => {
        
        let payload = {
            nResourceInstanceId: serviceRequestReadOnlyData.nResourceInstanceId,
            refExternalServicePartner: ExpID,
        }
        // axios.post("https://stagewebadmin.deasra.in:8050/server/service-request/update_externalservicepartner_id/", payload, {headers: {
        //     Authorization : "Token 11c2e5f0fc3aa6e71c5c5fc5211bd3ce692829a3"
        // }})
        api.updateExternalServicePartner(payload)
            .then((res) => {
                console.log(res.data.refExternalServicePartner)
                props.getMyServiceRequests()
                props.handleServiceRequestClick(serviceRequestReadOnlyData.nResourceInstanceId)
                setShowName(expert)
                if(AppData != undefined && AppData.status === null){
                    console.log("ID+++",AppData.id)
                    let payload ={
                        id:AppData.id
                    }
                    api.deleteExpertAppointment(payload)
                    .then(({data}) => {
                        console.log("Deleted",data)
                        if(data === "Appointment Deleted Successfully."){
                            toast("Appointment Deleted Successfully.", {
                                type: toast.TYPE.SUCCESS
                            })
                        }
                    })
                }
            })
        // api.saveServicePartner(payload).then((res) => {
        //     console.log("SHOWMENAME",res.data.refExternalServicePartner)
        //     setShowName(res.data.refExternalServicePartner)
        // })
        toast("Expert Assigned.", {
            type: toast.TYPE.SUCCESS,
        })
        props.handleServiceRequestClick(serviceRequestReadOnlyData.nResourceInstanceId)
        setIsTrue(true)

    }

    console.log("ShowNAme", showName)


    const serviceCost = (request) => {
        if (!request) return;

        let fPackageOfferAmount = "0";
        let fdeAsraPlatformCharges = "0";
        let fPackageOfferGST = "0";
        if (request.fPackageOfferAmount) {
            fPackageOfferAmount = request.fPackageOfferAmount.toString();
        }
        if (request.fPackageOfferGST) {
            fPackageOfferGST = request.fPackageOfferGST.toString();
        }
        if (request.fdeAsraPlatformCharges) {
            fdeAsraPlatformCharges = request.fdeAsraPlatformCharges.toString();
        }

        return "Pkg Service Cost With GST:" + fPackageOfferAmount.toString() + "\n" + "deAsra Platform Charges:" + fdeAsraPlatformCharges.toString() + "\n" + "GST On Platform Charges:" + fPackageOfferGST.toString();
    };

    const getCouponExpiryDate = (request) => {
        return "Coupon Expiry Date: " + moment(request.dtCouponExpiryDate).format("lll");
    };

    // let bookTime;
    //     let newTime = AppData.slot_time.split("-")
    //             let newTime1 = newTime[0]
    //             let ampm = newTime[1].split(" ")[1]

    //             let result = `${newTime1} ${ampm}`
    //              bookTime = moment(result, 'hh:mm A').format('HH:mm')
    //             console.log(bookTime)


    // let timeRN = moment(new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }),'hh:mm A').format('HH:mm')

    // const getServiceCostAmountAfterDiscount = (originalAmount, discountAmount) => {
    //     const gstRate = 0.18; // 18% GST Rate
    //     const basePrice = originalAmount / (1 + gstRate)
    //     const discountedPrice = basePrice - discountAmount
    //     const serviceCostAfterDiscountIncludingGst = discountedPrice * 1.18
    //     // return serviceCostAfterDiscountIncludingGst.toFixed(2)
    //     return serviceCostAmountAfterDiscountRoundOff(serviceCostAfterDiscountIncludingGst)
    // }

    const getServiceCostAmountAfterDiscount = (originalAmount, discountAmount, fdeAsraPlatformCharges, fPackageOfferGST) => {
        const gstRate = 0.18; // 18% GST Rate
        const basePrice = originalAmount / (1 + gstRate)
        const discountedPrice = Math.round(basePrice) - Math.round(discountAmount)
        let serviceCostAfterDiscountIncludingGst = discountedPrice * 1.18
        if (fdeAsraPlatformCharges !== null && fdeAsraPlatformCharges > 0) {
            serviceCostAfterDiscountIncludingGst += fdeAsraPlatformCharges + (fPackageOfferGST || 0);
        }
        // return serviceCostAfterDiscountIncludingGst.toFixed(2)
        return Math.round(serviceCostAfterDiscountIncludingGst)
    }
    const serviceCostAmountAfterDiscountRoundOff = (amount) => {
        return Math.round(amount);
    }

    return (

        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.toggleModal}
            ariaHideApp={false}

        >
            <ModalContent className="my-service-request-details-modal">

                <Modal isOpen={newModal}>
                    <ModalContent className="medium-general-modal">
                        <div className="modal-header">
                            <span className="modal-title">Expert Calender</span>
                            <img
                                alt="close"
                                id="Close"
                                src={close_modal}
                                className="close modal-close"
                                onClick={openCalenderModalIsFalse}
                            />
                        </div>
                 

                        <div className="modal-body">
                            <div>
                                <span className="spled-info-title conv-pb10 conv-pt10">Availability for Engagement with DeAsra</span>
                                <ReactTableFixedColumns
                                    minRows={0}
                                    data={ExpertPartner}
                                    columns={expertColumns}
                                    style={{ overflowY: "initial", height: "400px" }}
                                    className="-striped hide-scrollbar overflowcss"
                                />
                            </div>

                        </div>
                    </ModalContent>
                </Modal>

                {/* Info Model Experts */}

                <Modal isOpen={infoModal}>
                    <ModalContent className="medium-general-modal">
                        <div className="modal-header">
                            <span className="modal-title">Expert Details</span>
                            <img
                                alt="close"
                                id="Close"
                                src={close_modal}
                                className="close modal-close"
                                onClick={openInfoModalisFalse}
                            />
                        </div>

                        <div className="modal-body">
                            <div>
                                <ReactTableFixedColumns
                                    minRows={0}
                                    data={ExpertInfo}
                                    columns={columns}
                                    style={{ overflowY: "initial", height: "400px" }}
                                    className="-striped hide-scrollbar overflowcss"
                                />
                            </div>
                        </div>
                    </ModalContent>
                </Modal>

                {/* Book Appointment Modal */}

                <Modal isOpen={modalIsOpen}>
                    <ModalContent className="general-modal">
                        <div className="modal-header">
                            <span className="modal-title">Book an Expert Appointment</span>
                            <img
                                alt="close"
                                id="Close"
                                src={close_modal}
                                className="close modal-close"
                                onClick={() => {
                                    setStartDate(new Date)
                                    localStorage.removeItem("Resource")
                                    setModalIsOpenToFalse()
                                }
                                }
                            />
                        </div>
                        <div className="modal-body">
                            <div>
                                <span className="spled-colored-label" style={{ padding: '15px' }}>Expert Name :</span> <span className="spled-info-title">{ExpertName}</span>
                                {/* <div>
                                            <span className="spled-colored-label" style={{ padding: '15px' }}> Request ID: </span> <span className="spled-black-text">2</span>
                                        </div> */}
                                <div>
                                    <span className="spled-colored-label" style={{ padding: '15px' }}> Expert ID: </span> <span className="spled-black-text">{ExpertID}</span>
                                </div>
                                <div style={{
                                    display: 'flex'
                                }}>
                                    <div className="row container">
                                        <div className="col-6">
                                            <label className="my-services-model-value" style={{
                                                marginTop: '25px'
                                            }}>Book Appointment Date: </label>
                                            <DatePicker selected={startDate}
                                                dateFormat="dd/MM/yyyy" onChange={(date) => {
                                                    // let payloadDate1 = date.toLocaleDateString('en-CA')
                                                    var getYear = date.toLocaleString("default", { year: "numeric" });
                                                    var getMonth = date.toLocaleString("default", { month: "2-digit" });
                                                    var getDay = date.toLocaleString("default", { day: "2-digit" });
                                                    var payloadDate1 = getYear + "-" + getMonth + "-" + getDay;
                                                    setPayloadDate(payloadDate1)
                                                    console.log("PayloadDate==", payloadDate)
                                                    setStartDate(date)
                                                    console.log("NewDate==", startDate)
                                                    setExpertDay("")
                                                    setExpertTime("")
                                                }} minDate={new Date()} width="300px" />

                                        </div>

                                        <div className="col-6" >
                                            <label className="my-services-model-value" style={{
                                                marginTop: '25px',
                                                textAlign: 'center'
                                            }}>Book Appointment Day: </label>
                                            {/* <Select
                                                            styles={{
                                                                width: "50%",
                                                                // Fixes the overlapping problem of the component
                                                                menu: provided => ({ ...provided, zIndex: 3 })
                                                            }}
                                                            options={[{ label: day, value: day }]}
                                                            className='react-select-container'
                                                            onChange={(e) => {
                                                                setExpertDay(e.value)
                                                            }}></Select> */}
                                            {/* <select style={{
                                                        width: "65%",
                                                        height: '35px',
                                                        padding: '5px'
                                                    }}
                                                        // onChange={({ target }) => {
                                                        //     setExpertTime(target.value)
                                                        // }}
                                                        // value={expertTime}
                                                        required
                                                    >
                                                        <option value={day} selected disabled hidden>{day}</option>
                                                    </select> */}
                                            <input type="text" value={day} style={{
                                                opacity: "0.4",
                                                pointerEvents: "none",
                                                width: "65%",
                                                height: '40px',
                                                padding: '5px'
                                            }} />
                                        </div>

                                        {/* <div className="col-6">
                                                    <label className="my-services-model-value" style={{
                                                        marginTop: '25px'
                                                    }}>Book Appointment Time: </label>
                                                    <br />
                                                     <Select
                                                        styles={{
                                                            width: "30%",
                                                            color: 'blue',
                                                            // Fixes the overlapping problem of the component
                                                            menu: provided => ({ ...provided, zIndex: 3 })
                                                        }}
                                                        options={timeSlot.map((ele) => {
                                                           return [{ label: ele, value: ele }]
                                                        }
                                                        )}
                                                        className='react-select-container'
                                                        onChange={(e) => {
                                                            setExpertTime(e.label)
                                                        }}></Select> 
                                                        <select style={{
                                                            width: "65%",
                                                        }} 
                                                        onChange={({target}) => {
                                                            setExpertTime(target.value)
                                                        }}
                                                        // value={expertTime}
                                                        >
                                                            <option value="none" selected disabled hidden>Select an Option</option>
                                                            {
                                                                timeSlot.map((ele,id) => {
                                                                    return <option key= {id}>{ele}</option>
                                                                })
                                                            }
                                                        </select>
                                                </div> */}
                                    </div>
                                </div>
                                <div className="row container">
                                    {/* <div className="col-12" style={{
                                                        marginLeft: '15px'
                                                    }}>
                                                        <label className="my-services-model-value" style={{
                                                            marginTop: '25px',
                                                            textAlign: 'center'
                                                        }}>Book Appointment Day: </label>
                                                        <Select
                                                            styles={{
                                                                width: "50%",
                                                                // Fixes the overlapping problem of the component
                                                                menu: provided => ({ ...provided, zIndex: 3 })
                                                            }}
                                                            options={[{ label: day, value: day }]}
                                                            className='react-select-container'
                                                            onChange={(e) => {
                                                                setExpertDay(e.value)
                                                            }}></Select>
                                                    </div> */}
                                    <div className="col-6">
                                        <label className="my-services-model-value" style={{
                                            marginTop: '25px'
                                        }}>Book Appointment Time: </label>
                                        <br />
                                        {/* <Select
                                                        styles={{
                                                            width: "30%",
                                                            color: 'blue',
                                                            // Fixes the overlapping problem of the component
                                                            menu: provided => ({ ...provided, zIndex: 3 })
                                                        }}
                                                        options={timeSlot.map((ele) => {
                                                           return [{ label: ele, value: ele }]
                                                        }
                                                        )}
                                                        className='react-select-container'
                                                        onChange={(e) => {
                                                            setExpertTime(e.label)
                                                        }}></Select> */}
                                        <select style={{
                                            width: "65%",
                                            height: '40px',
                                            padding: '5px'
                                        }}
                                            onChange={({ target }) => {
                                                setExpertTime(target.value)
                                            }}
                                            value={expertTime ? expertTime : "new"}
                                            required
                                        >
                                            <option value="new" selected disabled>Select an Option</option>
                                            {
                                                timeSlot.map((ele, id) => {
                                                    return <option key={id}>{ele}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className="col-6" style={{
                                        // marginLeft : '10px'
                                    }}>
                                        <label className="my-services-model-value" style={{
                                            marginTop: '25px',
                                            textAlign: 'center',
                                        }}>Comments: </label>
                                        <textarea
                                            name="commentsAdded"
                                            className="w-100 h-50 form-control rounded"
                                            // value={serviceRequestEditableData.sFollowupNotes}
                                            onChange={(e) => {
                                                setCommentsText(e.target.value)
                                            }}
                                        // style={{ minHeight: "80px", maxHeight: "80px" }}
                                        />
                                    </div>
                                </div>





                                <div style={{
                                    margin: '10px',
                                    textAlign: 'center'
                                }}>
                                    <Button className="text-center" onClick={() => {

                                        bookExpert()
                                    }}>Book Appointment</Button>
                                </div>
                            </div>
                        </div>

                    </ModalContent>
                </Modal>


                {/* Update Price Modal */}

                <Modal isOpen={updatePriceModal}>
                    <ModalContent className="general-modal">
                        <div className="modal-header" style={{
                            backgroundColor: '#76287C',
                            color: '#fff'
                        }}>
                            <span className="modal-title">Update Price</span>
                            <img
                                alt="close"
                                id="Close"
                                src={close_modal}
                                className="close modal-close"
                                onClick={openPriceUpdateModalisFalse}
                            />
                        </div>

                        <div className="modal-body">
                        <div className={`${loadingPriceModal && "set-opacity"}`}>
                        {loadingPriceModal && <Spinner className="top" />}
                        <div className="row">
                                <div className="col m-2">
                                    <span className="spled-colored-label">Service Price</span> <span className="spled-black-text">: {serviceRequestReadOnlyData.fAmountFirst}</span>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-12 w-100">
                                    <input type="number" placeholder="New Service Amount (Including GST)" style={{
                                        width: "-webkit-fill-available",
                                        height: '45px'
                                    }}
                                        onKeyDown={(e) => {
                                            const invalidChars = ['=', '-', '+', 'e'];
                                            if (invalidChars.includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => setUpdatedAmount(e.target.value)} />
                                </div>
                            </div>
                            <div className="row m-2">
                                <div className="offset-3 col-6">
                                    <Button onClick={updatePriceButton}>Update Price</Button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </ModalContent>
                </Modal>

                <Modal isOpen={confirmUpdatePriceModal} style={{ zIndex: 1 }}>
				<ModalContent className="confirmation-modal-small">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Confirm</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={openConfirmUpdateModalisFalse}
						/>
					</div>

					<div className="modal-body">
						Are you sure you want to perform this action? Price set to 0(zero) will move this service to SPM.
						<div className="row">
							<div className="col-12 d-flex align-items-center" style={{
								justifyContent: 'flex-end'
							}}>
								<button
									type="button"
									className="my-services-model-submit-btn conv-mr25"
									onClick={confirmUpdateModalClick}
									>
									Yes
								</button>
								<button
									type="button"
									className="my-services-model-cancel-btn conv-mr25"
									onClick={() => {
										openConfirmUpdateModalisFalse()
									}}
									>
									No
								</button>
							</div>

						</div>
					</div>
				</ModalContent>
			</Modal>


                <div className="modal-header">
                    <span className="modal-title">Service Request Details</span>
                    <img
                        alt="close"
                        id="Close"
                        src={close_modal}
                        className="close modal-close"
                        onClick={() => {
                            localStorage.removeItem("APPID")
                            props.toggleModal()
                        }}
                    />
                </div>



                <div className={`modal-body spled-container notes-trail-content custom-scrollbar
                ${props.isLoadingInModal && "set-opacity"}`}>


                    <div className="row" style={{ height: "440px", overflow: "scroll", overflowX: "hidden" }}>
                        {props.isLoadingInModal && <Spinner className="center" />}


                        <div className="col-7 conv-mr0 verticle-divider-right conv-pb15">
                            <div className="row conv-mt10">
                                <div className="col-12 conv-pl20">
                                    <User className="cursor-pointer conv-brand-color"
                                        onClick={props.onUserProfileClick}
                                    />
                                    <span className="my-services-model-value conv-ml10">{serviceRequestReadOnlyData.sFirstName}&nbsp;{serviceRequestReadOnlyData.sLastName}</span>
                                    <span className="my-services-model-key conv-ml20"> {serviceRequestReadOnlyData.sEmailAddress}</span>
                                    <span className="my-services-model-key conv-ml20">{serviceRequestReadOnlyData.sContactNumber}</span>
                                    
                                    
                                </div>
                                <div className="col-12 conv-mt15 conv-pl20">
                                    <span className="my-services-model-stitle">
                                        {getServiceName(serviceRequestReadOnlyData.sServiceCode)}
                                        {/* {
                                            serviceRequestReadOnlyData.nPackageInstanceId? <>
                                            ({serviceRequestReadOnlyData.sPackageOfferTitle})
                                            </> : "" 
                                        } */}
                                        {
                                            serviceRequestReadOnlyData.nPackageInstanceId ? (
                                                <>({serviceRequestReadOnlyData.sPackageOfferTitle})</>
                                            ) : (
                                                (serviceRequestReadOnlyData.sServiceCode === "MKTLINKAGEEXHIBITION" ||
                                                    serviceRequestReadOnlyData.sServiceCode === "MKTLINKAGEBULKBUYER" ||
                                                    serviceRequestReadOnlyData.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
                                                    serviceRequestReadOnlyData.sServiceCode === "MKTLINKAGEEXPORT" ||
                                                    serviceRequestReadOnlyData.sServiceCode === "MKTLINKAGEECOM" ||
                                                    serviceRequestReadOnlyData.sServiceCode === "MKTLINKAGESHOPINSHOP") && (
                                                    <>({serviceRequestReadOnlyData.sServiceDisplayName})</>
                                                )
                                            ) || ""
                                        }
                                        {/* ({serviceRequestReadOnlyData.sServiceDisplayName}) */}
                                    </span>
                                    <span style={{ float: 'right' }}>
                                        {
                                            serviceRequestReadOnlyData.bMovedToSPM ?
                                                <span className="moved-to-spm-text">Moved To SPM</span> :
                                                ""
                                        }
                                    </span>
                                </div>
                                <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                            <span className="my-services-model-key">Service Request ID: </span>
                                            <span className="my-services-model-value">{serviceRequestReadOnlyData.nResourceInstanceId}</span>
                                            {AppData != undefined && AppData.status === null ? 
                                   <>
                                   <br />
                                   <span className="my-services-model-key">Booked Slot:</span>
                                   <span className="my-services-model-value conv-ml10">{AppData.slot_day},</span>
                                    <span className="my-services-model-value conv-ml5">{AppData.slot_time},</span>
                                    <span className="my-services-model-value conv-ml5">{AppData.bookdate}</span>
                                            {
                                                AppData.bookdate < CurrentDate || (AppData.bookdate === CurrentDate && bookTime < timeRN) ? 
                                                <span className="spled-black-text ml-3">Time Up</span> :
                                                <span className="spled-black-text">
                                                                        <small className="underlined-action spled-colored-label ml-3" onClick={deleteAppointment}>Cancel Slot</small>
                                                                    </span>
                                            }
                                    
                                   </> 
                                : ''}
                                        </div>
                                        <div className="col-6">
                                            <span className="my-services-model-key">External Service Partner: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.refExternalServicePartner && outerAssign === false ?
                                                    (
                                                        <>
                                                        {console.log("OuterNot")}
                                                            {serviceRequestReadOnlyData.refExternalServicePartner}
                                                            {serviceRequestReadOnlyData.ext_sp_org ? (" (" + serviceRequestReadOnlyData.ext_sp_org + ")") : ""}
                                                            <br />
                                                            {
                                                                serviceRequestReadOnlyData.sServiceCode === "LTEXP"
                                                                    || serviceRequestReadOnlyData.sServiceCode === "LTEXPCOACH"
                                                                    || serviceRequestReadOnlyData.sServiceCode === "EXPRTCONSULT"
                                                                    || serviceRequestReadOnlyData.sServiceCode === "GRPEXPRTCONSULT"
                                                                    ?
                                                                    <>
                                                                        <span className="spled-black-text"><small className={`underlined-action spled-colored-label
                                                                        ${serviceRequestReadOnlyData.bMovedToSPM ? "disable" : ''}`} onClick={() => {
                                                                            setOuterAssign(true)
                                                                            setShowName('')
                                                                        }}>Reassign</small></span>
                                                                        <span className="spled-black-text"> <small className={`underlined-action spled-colored-label
                                                                        ${AppData != undefined && AppData.status === null ? 'disable' : ''}
                                                                        ${serviceRequestReadOnlyData.bMovedToSPM ? "disable" : ''}`} onClick={() => {
                                                                            setModalIsOpenToTrue()
                                                                            getDatabyID()
                                                                        }}>Book Slot</small> </span>
                                                                    </> : ""
                                                            }

                                                        </>
                                                    ) : serviceRequestReadOnlyData.refExternalServicePartner && outerAssign === true 
                                                    && !showName 
                                                    ?
                                                            
                                                        <>
                                                            {console.log("Outeryes")}
                                                            <select 
                                                            classname={`${serviceRequestReadOnlyData.bMovedToSPM ? "disable" : ''}`}
                                                            style={{
                                                                    width: "75%",
                                                                    height: "35px"
                                                                }}
                                                                    onChange={({ target }) => {
                                                                        setExpert(target.value)
                                                                    }}
                                                                // value={expertTime}
                                                                >
                                                                    <option value="" selected disabled hidden>Select an Option</option>
                                                                    {
                                                                        Experts.map((ele, id) => {
                                                                            return <option key={id}>{ele}</option>
                                                                        })
                                                                    }
                                                                </select>
                                                                    
                                                                <button
                                                                    style={{
                                                                        marginLeft: '10px'
                                                                    }}
                                                                    className={`my-services-model-submit-btn conv-pr15 conv-pl15 ${serviceRequestReadOnlyData.bMovedToSPM ? "disable" : ''}`}
                                                                    onClick={SaveExpert1}>Save</button>
                                                                    {/* <button className="my-services-model-submit-btn conv-pr15 conv-pl15" onClick={() => {
                                                                        setOuterAssign(false)
                                                                    }}>Cancel</button> */}
                                                                    <span className="spled-black-text">
                                                                        <small className="underlined-action spled-colored-label" onClick={() => {
                                                                            setOuterAssign(false)
                                                                        }}>Cancel</small>
                                                                    </span>
                                                            </>
                                                        
                                               
                                                    

                                                    : serviceRequestReadOnlyData.refExternalServicePartner && outerAssign === true && showName ? 
                                                    <>
                                                        {showName}
                                                        <br />
                                                        <span className="spled-black-text"><small className="underlined-action spled-colored-label" onClick={() => {
                                                                            setOuterAssign(true)
                                                                            setShowName('')
                                                                        }}>Reassign</small></span>
                                                        <span className="spled-black-text ml-1 mr-1"> <small className={`underlined-action spled-colored-label
                                                                        ${AppData != undefined && AppData.status === null ? 'disable' : ''}`} onClick={() => {
                                                                            setModalIsOpenToTrue()
                                                                            getDatabyID()
                                                                        }}>Book Slot</small> </span>
                                                    </>
                                                    :

                                                    
                                                    serviceRequestReadOnlyData.sServiceCode === "LTEXP"
                                                        || serviceRequestReadOnlyData.sServiceCode === "LTEXPCOACH"
                                                        || serviceRequestReadOnlyData.sServiceCode === "EXPRTCONSULT"
                                                        || serviceRequestReadOnlyData.sServiceCode === "GRPEXPRTCONSULT" ?

                                                        showName && isTrue ? <>
                                                            {showName}
                                                            <br />
                                                            <span className="spled-black-text"><small className="underlined-action spled-colored-label" onClick={() => {
                                                                            setIsTrue(false)
                                                                            setShowName('')
                                                                        }}>Reassign</small></span>
                                                            {/* <button
                                                                style={{
                                                                    marginLeft: '10px'
                                                                }}
                                                                className="my-services-model-submit-btn conv-pr15 conv-pl15"
                                                                onClick={() => {
                                                                    setIsTrue(false)
                                                                    setShowName('')
                                                                }}>Reassign</button> */}
                                                                <span className="spled-black-text ml-1 mr-1"> <small className={`underlined-action spled-colored-label
                                                                        ${AppData != undefined && AppData.status === null ? 'disable' : ''}`} onClick={() => {
                                                                            setModalIsOpenToTrue()
                                                                            getDatabyID()
                                                                        }}>Book Slot</small> </span>
                                                                
                                                        </> :
                                                            <>
                                                                {
                                                                    serviceRequestReadOnlyData.bMovedToSPM ?
                                                                    <select style={{
                                                                        width: "75%",
                                                                        height: "35px",
                                                                        pointerEvents:'none',
                                                                        opacity: '0.4'
                                                                        
                                                                    }}
                                                                    classname={`${serviceRequestReadOnlyData.bMovedToSPM ? "disable" : ''}`}
                                                                        onChange={({ target }) => {
                                                                            setExpert(target.value)
                                                                        }}
                                                                    // value={expertTime}
                                                                    >
                                                                        <option value="" selected disabled hidden>Select an Option</option>
                                                                        {
                                                                            Experts.map((ele, id) => {
                                                                                return <option key={id}>{ele}</option>
                                                                            })
                                                                        }
                                                                    </select>
                                                                    :
                                                                    <select style={{
                                                                        width: "75%",
                                                                        height: "35px",
                                                                        
                                                                    }}
                                                                    classname={`${serviceRequestReadOnlyData.bMovedToSPM ? "disable" : ''}`}
                                                                        onChange={({ target }) => {
                                                                            setExpert(target.value)
                                                                        }}
                                                                    // value={expertTime}
                                                                    >
                                                                        <option value="" selected disabled hidden>Select an Option</option>
                                                                        {
                                                                            Experts.map((ele, id) => {
                                                                                return <option key={id}>{ele}</option>
                                                                            })
                                                                        }
                                                                    </select>
                                                                }

                                                                <button
                                                                    style={{
                                                                        marginLeft: '10px'
                                                                    }}
                                                                    className={`my-services-model-submit-btn conv-pr15 conv-pl15 ${serviceRequestReadOnlyData.bMovedToSPM ? "disable" : ''}`}
                                                                    onClick={SaveExpert}>Save</button>
                                                            </>

                                                        :
                                                        "NA"}
                                                {/* <br /> */}
                                                {
                                                    serviceRequestReadOnlyData.sServiceCode === "LTEXP"
                                                        || serviceRequestReadOnlyData.sServiceCode === "LTEXPCOACH"
                                                        || serviceRequestReadOnlyData.sServiceCode === "EXPRTCONSULT"
                                                        || serviceRequestReadOnlyData.sServiceCode === "GRPEXPRTCONSULT"
                                                        ?
                                                        <>
                                                            <span title="View Expert Calendar" className="spled-black-text" style={{
                                                                cursor: "pointer",
                                                                // marginLeft: "20px"
                                                            }} onClick={openCalenderModalIsTrue}>
                                                                 {/* <img src="https://www.pngfind.com/pngs/m/122-1228829_calendar-png-download-image-calendar-icon-png-transparent.png" width={27} height={27} alt="" /> */}
                                                                 <small className="underlined-action spled-colored-label" onClick={openCalenderModalIsTrue}>Expert Calendar</small>
                                                                  </span>
                                                            <span title="Exert Details" onClick={openInfoModalisTrue} style={{
                                                                cursor: "pointer",
                                                                marginLeft: "20px"
                                                            }}>
                                                                <Info style={{ marginLeft: "10px", width: "15px" }} />
                                                                </span>
                                                        </>
                                                        : ""
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                            <span className="my-services-model-key">Requested Date: </span>
                                            <span className="my-services-model-value">
                                                {moment(serviceRequestReadOnlyData.dtRequested).format("lll") || ("Not Available")}
                                            </span>
                                        </div>
                                        <div className="col-6">
                                            <span className="my-services-model-key">Facilitator: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.refFacilitator ?
                                                    serviceRequestReadOnlyData.refFacilitator : "Not Available"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                            <span className="my-services-model-key">Sector: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.business_sector_name || ("Not Available")}
                                            </span>
                                            <span className="my-services-model-key conv-ml15">Device Type: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.sDeviceType ?
                                                    serviceRequestReadOnlyData.sDeviceType : ("Not Available")}
                                            </span>
                                        </div>
                                        <div className="col-6">
                                            <span className="my-services-model-key">EHH: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.sExternalHHEmail ?
                                                    serviceRequestReadOnlyData.sExternalHHEmail : "Not Available"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                            <span className="my-services-model-key">Total Service Cost In Pkg: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.fPackageOfferTotalServiceCharge ?
                                                    serviceRequestReadOnlyData.fPackageOfferTotalServiceCharge + " (Incl. GST)" : "NA"}
                                                <span style={{ cursor: "pointer" }} title={serviceCost(serviceRequestReadOnlyData)}>
                                                    <Info style={{ marginLeft: "10px", width: "15px" }} />
                                                </span>
                                            </span>
                                        </div>
                                        <div className="col-6">
                                            <span className="my-services-model-key">Org: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.sEhhOrg ?
                                                    serviceRequestReadOnlyData.sEhhOrg : "Not Available"}
                                            </span>
                                            <span className="my-services-model-key conv-ml15">Contact: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.sEhhContactNumber ?
                                                    serviceRequestReadOnlyData.sEhhContactNumber : "Not Available"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                            <span className="my-services-model-key">Entry Point: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.sEntryPoint ?
                                                    serviceRequestReadOnlyData.sEntryPoint : "Not Available"}
                                            </span>
                                        </div>
                                        <div className="col-6">
                                            <span className="my-services-model-key">Stay Engaged with EHH: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.bStayEngagedWithEhh ? "Yes" : "No"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                            <span className="my-services-model-key">Package Name: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.sPackageOfferTitle ?
                                                    serviceRequestReadOnlyData.sPackageOfferTitle : "Not Available"}
                                            </span>
                                        </div>
                                        <div className="col-6">
                                            <span className="my-services-model-key">Coupon Applied: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.bCouponApplied ?
                                                    (
                                                        <>
                                                            {serviceRequestReadOnlyData.dtCouponExpiryDate ?
                                                                (
                                                                    <>
                                                                        {
                                                                            new Date(serviceRequestReadOnlyData.dtCouponExpiryDate) < new Date() ?
                                                                                (
                                                                                    <>
                                                                                        <span style={{ color: "red" }}>Yes</span>
                                                                                        <span title={getCouponExpiryDate(serviceRequestReadOnlyData)}>
                                                                                            <Info style={{ marginLeft: "10px", width: "15px" }} />
                                                                                        </span>
                                                                                    </>
                                                                                ) :
                                                                                (
                                                                                    <>
                                                                                        <span style={{ color: "green" }}>Yes</span>
                                                                                        <span title={getCouponExpiryDate(serviceRequestReadOnlyData)}>
                                                                                            <Info style={{ marginLeft: "10px", width: "15px" }} />
                                                                                        </span>
                                                                                    </>
                                                                                )
                                                                        }
                                                                    </>
                                                                ) :
                                                                (
                                                                    <>
                                                                        <span>Yes</span>
                                                                        <span title={"Coupon Expiry Date: Not Available"}>
                                                                            <Info style={{ marginLeft: "10px", width: "15px" }} />
                                                                        </span>
                                                                    </>
                                                                )}
                                                        </>
                                                    ) :
                                                    (
                                                        "No"
                                                    )}
                                            </span>
                                            <span className="my-services-model-key conv-ml15">Coupon Code: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.sCouponCode ?
                                                    (
                                                        <>
                                                            {serviceRequestReadOnlyData.dtCouponExpiryDate ?
                                                                (
                                                                    <>
                                                                        {
                                                                            new Date(serviceRequestReadOnlyData.dtCouponExpiryDate) < new Date() ?
                                                                                (<span style={{ color: "red" }}>{serviceRequestReadOnlyData.sCouponCode}</span>) :
                                                                                (<span style={{ color: "green" }}>{serviceRequestReadOnlyData.sCouponCode}</span>)
                                                                        }
                                                                    </>
                                                                ) :
                                                                (
                                                                    <span>{serviceRequestReadOnlyData.sCouponCode}</span>
                                                                )}
                                                        </>
                                                    ) :
                                                    (
                                                        "NA"
                                                    )}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                            <span className="my-services-model-key">Package ID: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.nPackageInstanceId ?
                                                    serviceRequestReadOnlyData.nPackageInstanceId : "NA"}
                                            </span>
                                        </div>
                                        <div className="col-6">
                                            <span className="my-services-model-key">Discount Amount: </span>
                                            <span className="my-services-model-value">
                                                {/* {serviceRequestReadOnlyData.fDiscountAmount ?
                                                    (
                                                        <>
                                                            {serviceRequestReadOnlyData.dtCouponExpiryDate ?
                                                                (
                                                                    <>
                                                                        {
                                                                            new Date(serviceRequestReadOnlyData.dtCouponExpiryDate) < new Date() ?
                                                                                (<span style={{ color: "red" }}>{Number.isInteger(serviceRequestReadOnlyData.fDiscountAmount) ? serviceRequestReadOnlyData.fDiscountAmount : Number(serviceRequestReadOnlyData.fDiscountAmount)?.toFixed(2)}</span>) :
                                                                                (<span style={{ color: "green" }}>{Number?.isInteger(serviceRequestReadOnlyData.fDiscountAmount) ? serviceRequestReadOnlyData.fDiscountAmount : Number(serviceRequestReadOnlyData.fDiscountAmount)?.toFixed(2)}</span>)
                                                                        }
                                                                    </>
                                                                ) :
                                                                (
                                                                    <span>{Number.isInteger(serviceRequestReadOnlyData.fDiscountAmount) ? serviceRequestReadOnlyData.fDiscountAmount : Number(serviceRequestReadOnlyData.fDiscountAmount).toFixed(2)}</span>
                                                                )}
                                                        </>
                                                    ) :
                                                    (
                                                        "NA"
                                                    )} */}
                                                     {serviceRequestReadOnlyData.fDiscountAmount ?
                                                    (
                                                        <>
                                                            {serviceRequestReadOnlyData.dtCouponExpiryDate ?
                                                                (
                                                                    <>
                                                                        {
                                                                            new Date(serviceRequestReadOnlyData.dtCouponExpiryDate) < new Date() ?
                                                                                (<span style={{ color: "red" }}>{Math.round(serviceRequestReadOnlyData.fDiscountAmount)}</span>) :
                                                                                (<span style={{ color: "green" }}>{Math.round(serviceRequestReadOnlyData.fDiscountAmount)}</span>)
                                                                        }
                                                                    </>
                                                                ) :
                                                                (
                                                                    <span>{Math.round(serviceRequestReadOnlyData.fDiscountAmount)}</span>
                                                                )}
                                                        </>
                                                    ) :
                                                    (
                                                        "NA"
                                                    )}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                            <span className="my-services-model-key">DND Date:  </span>
                                            <span className="my-services-model-value">
                                                {props.DNDDate ? moment(props.DNDDate).format("lll") : "Not Available"}
                                            </span>
                                            <a className={`my-services-dnd-link con-cursor-pointer conv-ml15 ${DND_LINK ? "" : " disable"}`} href={DND_LINK} target="_blank">Extend DND</a>
                                        </div>
                                        <div className="col-6">
                                            <span className="my-services-model-key">Service Cost After Discount: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.fDiscountAmount ?
                                                    (
                                                        <>
                                                            {serviceRequestReadOnlyData.dtCouponExpiryDate ?
                                                                (
                                                                    <>
                                                                        {
                                                                            new Date(serviceRequestReadOnlyData.dtCouponExpiryDate) < new Date() ?
                                                                                (<span style={{ color: "red" }}>{serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount}</span>) :
                                                                                (<span style={{ color: "green" }}>{serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount}</span>)
                                                                        }
                                                                    </>
                                                                ) :
                                                                (
                                                                    <span>{serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount}</span>
                                                                )}
                                                        </>
                                                    ) :
                                                    (
                                                        "NA"
                                                    )}
                                            </span>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                            <span className="my-services-model-key">DND Date:  </span>
                                            <span className="my-services-model-value">
                                                {props.DNDDate ? moment(props.DNDDate).format("lll") : "Not Available"}
                                            </span>
                                            <a className={`my-services-dnd-link con-cursor-pointer conv-ml15 ${DND_LINK ? "" : " disable"}`} href={DND_LINK} target="_blank">Extend DND</a>
                                        </div>
                                        {/* <div className="col-6">
                                            <span className="my-services-model-key">Service Cost After Discount (Inclusive of Taxes): </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.fDiscountAmount ?
                                                    (serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount) === 0 ?
                                                        "0"
                                                    :
                                                    serviceRequestReadOnlyData.nPackageInstanceId ?
                                                        (
                                                            <>
                                                            {serviceRequestReadOnlyData.fDiscountAmount > serviceRequestReadOnlyData.fPackageOfferAmount ?
                                                            <span>0</span>
                                                            :
                                                            serviceRequestReadOnlyData.dtCouponExpiryDate ?
                                                                (
                                                                    <>
                                                                        {
                                                                            new Date(serviceRequestReadOnlyData.dtCouponExpiryDate) < new Date() ?
                                                                                (<span style={{ color: "red" }}>{Number.isInteger(serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount) ? serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount : Number(serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount)?.toFixed(2)}</span>) :
                                                                                (<span style={{ color: "green" }}>{Number.isInteger(serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount) ? serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount : Number(serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount)?.toFixed(2) }</span>)
                                                                        }
                                                                    </>
                                                                ) :
                                                                (
                                                                    <span>{Number.isInteger(serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount) ? serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount : Number(serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount).toFixed(2)}</span>
                                                                )}
                                                        </>
                                                        )
                                                        :
                                                        (
                                                            <>
                                                                {
                                                                    serviceRequestReadOnlyData.sPaymentMode === "2_Step_Payment" ?
                                                                        (
                                                                            serviceRequestReadOnlyData.fDiscountAmount > serviceRequestReadOnlyData.fAmountFirst ? (
                                                                                <span style={{ color: "green" }}>
                                                                                  {Number.isInteger(serviceRequestReadOnlyData.fAmountFirst - (serviceRequestReadOnlyData.fDiscountAmount - serviceRequestReadOnlyData.fAmountFirst)) ? serviceRequestReadOnlyData.fAmountFirst - (serviceRequestReadOnlyData.fDiscountAmount - serviceRequestReadOnlyData.fAmountFirst) : Number(serviceRequestReadOnlyData.fAmountFirst - (serviceRequestReadOnlyData.fDiscountAmount - serviceRequestReadOnlyData.fAmountFirst)).toFixed(2)}
                                                                                </span>
                                                                            ):(
                                                                                <span>{Number.isInteger(serviceRequestReadOnlyData.fAmountFirst) ? serviceRequestReadOnlyData.fAmountFirst : Number(serviceRequestReadOnlyData.fAmountFirst).toFixed(2)}</span>
                                                                            )
                                                                        )
                                                                        :
                                                                        serviceRequestReadOnlyData.dtCouponExpiryDate ?
                                                                            (
                                                                                <>
                                                                                    {
                                                                                        new Date(serviceRequestReadOnlyData.dtCouponExpiryDate) < new Date() ?
                                                                                            // (<span style={{ color: "red" }}>{serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount}</span>) :
                                                                                            // (<span style={{ color: "green" }}>{serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount}</span>)
                                                                                            // (<span style={{ color: "red" }}>{Math.round(((serviceRequestReadOnlyData.fAmountFirst * (100/118)) - serviceRequestReadOnlyData.fDiscountAmount)*(118/100))}</span>) :
                                                                                            // (<span style={{ color: "green" }}>{Math.round(((serviceRequestReadOnlyData.fAmountFirst * (100/118)) - serviceRequestReadOnlyData.fDiscountAmount)*(118/100))}</span>)
                                                                                            // (<span style={{ color: "red" }}>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fAmountFirst,serviceRequestReadOnlyData.fDiscountAmount)}</span>) :
                                                                                            (<span style={{ color: "red" }}>{Number.isInteger(serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount) ? serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount : Number(serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount).toFixed(2)}</span>) :
                                                                                            // (<span style={{ color: "green" }}>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fAmountFirst,serviceRequestReadOnlyData.fDiscountAmount)}</span>)
                                                                                            (<span style={{ color: "green" }}>{Number.isInteger(serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount) ? serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount : Number(serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount).toFixed(2)}</span>)
                                                                                    }
                                                                                </>
                                                                            ) :
                                                                            (
                                                                                // <span>{serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount}</span>
                                                                                <span>{Number.isInteger(serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount) ? serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount : Number(serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount).toFixed(2) }</span>                                                                                
                                                                            )
                                                                }
                                                            </>
                                                        )
                                                    :
                                                    (
                                                        "NA"
                                                    )}
                                            </span>
                                        </div> */}
                                         <div className="col-6">
                                            <span className="my-services-model-key">Service Cost After Discount (Inclusive of Taxes): </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.fDiscountAmount ?
                                                    (serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount) === 0 ?
                                                        "0"
                                                    :
                                                    serviceRequestReadOnlyData.nPackageInstanceId ?
                                                        (
                                                            <>
                                                                {serviceRequestReadOnlyData.fDiscountAmount > serviceRequestReadOnlyData.fPackageOfferAmount ?
                                                                <span>0</span>
                                                                :
                                                                serviceRequestReadOnlyData.dtCouponExpiryDate ?
                                                                    (
                                                                        <>
                                                                            {
                                                                                new Date(serviceRequestReadOnlyData.dtCouponExpiryDate) < new Date() ?
                                                                                    // (<span style={{ color: "red" }}>{serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount}</span>) :
                                                                                    // (<span style={{ color: "green" }}>{serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount}</span>)

                                                                                    // (<span style={{ color: "red" }}>{serviceCostAmountAfterDiscountRoundOff(serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount)}</span>) :
                                                                                    // (<span style={{ color: "green" }}>{serviceCostAmountAfterDiscountRoundOff(serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount)}</span>)
                                                                                    (<span style={{ color: "red" }}>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fPackageOfferAmount,serviceRequestReadOnlyData.fDiscountAmount, serviceRequestReadOnlyData?.fdeAsraPlatformCharges, serviceRequestReadOnlyData?.fPackageOfferGST)}</span>) :
                                                                                            (<span style={{ color: "green" }}>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fPackageOfferAmount,serviceRequestReadOnlyData.fDiscountAmount, serviceRequestReadOnlyData?.fdeAsraPlatformCharges, serviceRequestReadOnlyData?.fPackageOfferGST)}</span>)
                                                                            }
                                                                        </>
                                                                    ) :
                                                                    (
                                                                        // <span>{serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount}</span>
                                                                        // <span>{serviceCostAmountAfterDiscountRoundOff(serviceRequestReadOnlyData.fPackageOfferAmount - serviceRequestReadOnlyData.fDiscountAmount)}</span>
                                                                        <span>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fPackageOfferAmount, serviceRequestReadOnlyData.fDiscountAmount, serviceRequestReadOnlyData?.fdeAsraPlatformCharges, serviceRequestReadOnlyData?.fPackageOfferGST)}</span>
                                                                    )}
                                                            </>
                                                        )
                                                        :
                                                        (
                                                            <>
                                                                {
                                                                    serviceRequestReadOnlyData.sPaymentMode === "2_Step_Payment" ?
                                                                        (
                                                                            // serviceRequestReadOnlyData.fDiscountAmount > serviceRequestReadOnlyData.fAmountFirst ? (
                                                                            //     <span style={{ color: "green" }}>
                                                                            //       {serviceRequestReadOnlyData.fAmountFirst - (serviceRequestReadOnlyData.fDiscountAmount - serviceRequestReadOnlyData.fAmountFirst)}
                                                                            //     </span>
                                                                            // ):(
                                                                            //     <span>{serviceRequestReadOnlyData.fAmountFirst}</span>
                                                                            // )
                                                                            <>
                                                                                    {serviceRequestReadOnlyData.fDiscountAmount > serviceRequestReadOnlyData.fAmountFirst ?
                                                                                        <>

                                                                                            {
                                                                                                new Date(serviceRequestReadOnlyData.dtCouponExpiryDate) < new Date() ?
                                                                                                    (<span style={{ color: "red" }}>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fAmountFull, serviceRequestReadOnlyData.fDiscountAmount, serviceRequestReadOnlyData?.fdeAsraPlatformCharges, serviceRequestReadOnlyData?.fPackageOfferGST)}</span>) :
                                                                                                    (<span style={{ color: "green" }}>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fAmountFull, serviceRequestReadOnlyData.fDiscountAmount, serviceRequestReadOnlyData?.fdeAsraPlatformCharges, serviceRequestReadOnlyData?.fPackageOfferGST)}</span>)
                                                                                            }
                                                                                        </>
                                                                                        :
                                                                                        <span>{serviceRequestReadOnlyData.fAmountFirst}</span>
                                                                                    }
                                                                                </>
                                                                        )
                                                                        :
                                                                        serviceRequestReadOnlyData.dtCouponExpiryDate ?
                                                                            (
                                                                                <>
                                                                                    {
                                                                                        new Date(serviceRequestReadOnlyData.dtCouponExpiryDate) < new Date() ?
                                                                                            // (<span style={{ color: "red" }}>{serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount}</span>) :
                                                                                            // (<span style={{ color: "green" }}>{serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount}</span>)
                                                                                            // (<span style={{ color: "red" }}>{Math.round(((serviceRequestReadOnlyData.fAmountFirst) - serviceRequestReadOnlyData.fDiscountAmount))}</span>) :
                                                                                            // (<span style={{ color: "green" }}>{Math.round(((serviceRequestReadOnlyData.fAmountFirst) - serviceRequestReadOnlyData.fDiscountAmount))}</span>)
                                                                                            // (<span style={{ color: "red" }}>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fAmountFirst,serviceRequestReadOnlyData.fDiscountAmount)}</span>) :
                                                                                            // (<span style={{ color: "green" }}>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fAmountFirst,serviceRequestReadOnlyData.fDiscountAmount)}</span>)
                                                                                            (<span style={{ color: "red" }}>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fAmountFirst, serviceRequestReadOnlyData.fDiscountAmount, serviceRequestReadOnlyData?.fdeAsraPlatformCharges, serviceRequestReadOnlyData?.fPackageOfferGST)}</span>) :
                                                                                            (<span style={{ color: "green" }}>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fAmountFirst, serviceRequestReadOnlyData.fDiscountAmount, serviceRequestReadOnlyData?.fdeAsraPlatformCharges, serviceRequestReadOnlyData?.fPackageOfferGST)}</span>)
                                                                                    
                                                                                    }
                                                                                </>
                                                                            ) :
                                                                            (
                                                                                // <span>{serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount}</span>
                                                                                // <span>{serviceCostAmountAfterDiscountRoundOff(serviceRequestReadOnlyData.fAmountFirst - serviceRequestReadOnlyData.fDiscountAmount)}</span>
                                                                                <span>{getServiceCostAmountAfterDiscount(serviceRequestReadOnlyData.fAmountFirst, serviceRequestReadOnlyData.fDiscountAmount, serviceRequestReadOnlyData?.fdeAsraPlatformCharges, serviceRequestReadOnlyData?.fPackageOfferGST)}</span>
                                                                                
                                                                            )
                                                                }
                                                            </>
                                                        )
                                                    :
                                                    (
                                                        "NA"
                                                    )}
                                            </span>
                                        </div>
                                    </div>
                                </div>     

                                <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                            {/* <span className="my-services-model-key">Package ID: </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.nPackageInstanceId ?
                                                    serviceRequestReadOnlyData.nPackageInstanceId : "NA"}
                                            </span> */}
                                        </div>
                                        {
                                            props.newServiceRequestId && <div className="col-6 text-center">
                                                <div style={{backgroundColor: '#78417C', padding: 10}}>
                                            <span className="my-services-model-value" style={{color: '#fff'}}>New Service ID: </span>
                                            <span className="my-services-model-value" style={{color: '#fff'}}>
                                                {props.newServiceRequestId}
                                                    <img
                                                        alt="copy"
                                                        src={copysvg}
                                                        height={"20px"}
                                                        width={"16px"}
                                                        // style={{marginLeft: 10}}
                                                        className="con-cursor-pointer conv-mr13 conv-ml10"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            copyToClipboard(props.newServiceRequestId);
                                                            toast(`${props.newServiceRequestId} Copied!`, {
                                                                autoClose: 5000,
                                                                type: toast.TYPE.SUCCESS,
                                                            });
                                                        }}
                                                    />
                                            </span>
                                            </div>
                                        </div>
                                        }
                                        
                                    </div>
                                </div>                  

                                <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                        {/* {
                                                serviceRequestReadOnlyData.sPackageOfferTitle &&
                                                <span className="my-services-model-value">
                                                    <button
                                                        type="button"
                                                        className="my-services-model-cancel-btn conv-mr15"
                                                        onClick={props.handleCloseBtnClick}
                                                    >
                                                        Close Service
                                                    </button>
                                                </span>
                                            }
                                            <span className="my-services-model-value"></span> */}
                                        </div>
                                        <div className="col-6 d-flex">
                                            <span className="my-services-model-key">
                                                {
                                                    // serviceRequestReadOnlyData.sMode === "DYNAMIC_DeAsraDriven" && serviceRequestReadOnlyData.fAmountFull === 0 ?
                                                    (serviceRequestReadOnlyData?.sMode === "DYNAMIC_DeAsraDriven" ||
                                                        (
                                                            serviceRequestReadOnlyData?.sPackageOfferTitle === 'Long Term Engagement Package' &&
                                                            (
                                                                serviceRequestReadOnlyData?.refExternalServicePartner === 'Mr. Sudhir Gijare' ||
                                                                serviceRequestReadOnlyData?.ext_sp_org === 'Mr. Sudhir Gijare'
                                                            )
                                                        ))
                                                        // && row.original.fAmountFull === 0
                                                        && (serviceRequestReadOnlyData.refSRState === "Eligible"
                                                            || serviceRequestReadOnlyData.refSRState === "Requested"
                                                            || serviceRequestReadOnlyData.refSRState === "Prepared"
                                                            || serviceRequestReadOnlyData.refSRState === "Partial/ Full Payment Pending" && !serviceRequestReadOnlyData.urlPayment
                                                        )
                                                        ?
                                                        // isPriceUpdated === false ?
                                                        <button
                                                            type="button"
                                                            className="my-services-model-cancel-btn conv-mr25"
                                                            onClick={openPriceUpdateModalisTrue}>
                                                            Update Price
                                                        </button>

                                                            :
                                                            ""
                                                }
                                            </span>

                                            {
                                                serviceRequestReadOnlyData.sPackageOfferTitle === "Long Term Engagement Package" && 
                                                (
                                                    props.isLoadingInModal ? 
                                                    <span className="my-services-model-value">
                                                <button
                                                    type="button"
                                                    className="my-services-model-submit-btn conv-mr15"
                                                    style={{pointerEvents: "none", opacity: 0.4}}
                                                    >
                                                    Create New Service
                                                </button>
                                            </span>
                                            :
                                            <span className="my-services-model-value">
                                                <button
                                                    type="button"
                                                    className="my-services-model-submit-btn conv-mr15"
                                                    onClick={props.handleCreateNewServiceBtn}
                                                    >
                                                    Create New Service
                                                </button>
                                            </span>
                                                )
                                                
                                            }

                                           


                                        </div>
                                    </div>
                                </div>

                                {
                                    serviceRequestReadOnlyData.sSpeakerName ? 
                                    <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-6">
                                        <span className="my-services-model-key">Speaker:  </span>
                                            <span className="my-services-model-value">
                                                {serviceRequestReadOnlyData.sSpeakerName}
                                                {serviceRequestReadOnlyData.sSpeakerOrganization ? (" (" + serviceRequestReadOnlyData.sSpeakerOrganization + ")") : ""}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                        :
                                        ""
                                }
                                
                                <div className="col-12 conv-mt15 conv-pl20">
                                    <div className="row">
                                        <div className="col-3">

                                            <a className={`my-services-dnd-link con-cursor-pointer 
                                            ${serviceRequestReadOnlyData.urlInvoice ? "" : "disable"}`}
                                                href={serviceRequestReadOnlyData.urlInvoice}
                                                target="_blank">
                                                Break-up
                                            </a>
                                        </div>

                                        <div className="col-4">

                                            <a className={`my-services-dnd-link conv-ml60 con-cursor-pointer
                                            ${serviceRequestReadOnlyData.currentState === "Payment Received" ? "disable" : ""} 
                                            ${props.catalogueMode !== "DYNAMIC" ? "disable" : ""} 
                                            ${serviceRequestReadOnlyData.paymentMode === "No_Payment" ? "disable" : ""} 
                                            ${serviceRequestReadOnlyData.paymentMode === "SP_paid_service" ? "disable" : ""}
                                            ${serviceRequestReadOnlyData.sPaymentReceiver === "Partner" ? 'disable' : ''} 
                                            `}
                                            
                                                href={URL_CALCULATOR + String(serviceRequestReadOnlyData.nResourceInstanceId)}
                                                target="_blank">
                                                Re-calculate
                                            </a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="col-5 conv-mr0">
                            <div className="row conv-mt10">
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-6 width-100">
                                            <label className="my-services-model-value">Follow Up On*</label>
                                            <ReactDatePicker
                                                dateFormat="dd/MM/yyyy"
                                                selected={serviceRequestEditableData.dtFollowupOn}
                                                onChange={(date) => props.onInputChange("dtFollowupOn", date)}
                                                minDate={new Date()}
                                                placeholderText="Follow Up On"
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label className="my-services-model-value">Need To Talk To SP</label>
                                            <Select
                                                styles={{
                                                    // Fixes the overlapping problem of the component
                                                    menu: provided => ({ ...provided, zIndex: 3 })
                                                }}
                                                options={props.needToTalkToSPOptions}
                                                onChange={props.setSelectedNeedToTalkToSPOption}
                                                value={props.selectedNeedToTalkToSPOption}
                                                className='react-select-container'
                                                classNamePrefix="react-select"
                                                theme={theme => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary: '#76287C',
                                                        primary25: '#F4DFF4',
                                                    },
                                                })}
                                            ></Select>
                                        </div>




                                        {
                                            serviceRequestReadOnlyData.sServiceCode === "UDYAMREG" || serviceRequestReadOnlyData.sServiceCode === "BOOKACCBALKEEP" || serviceRequestReadOnlyData.sServiceCode === "PARTSHIPDEED"
                                                || serviceRequestReadOnlyData.sServiceCode === "ITR" || serviceRequestReadOnlyData.sServiceCode === "GSTREG" || serviceRequestReadOnlyData.sServiceCode === "GSTRETURNFILING"
                                                || serviceRequestReadOnlyData.sServiceCode === "OPCFORM" || serviceRequestReadOnlyData.sServiceCode === "PVTLTDCOMP" || serviceRequestReadOnlyData.sServiceCode === "LVLICENSEAGRREG"
                                                || serviceRequestReadOnlyData.sServiceCode === "TRADMRK" || serviceRequestReadOnlyData.sServiceCode === "COPYRIGHT" || serviceRequestReadOnlyData.sServiceCode === "SHOPACT"
                                                || serviceRequestReadOnlyData.sServiceCode === "FSSAI" || serviceRequestReadOnlyData.sServiceCode === "FSSAILICENSE" || serviceRequestReadOnlyData.sServiceCode === "LLPFORM"
                                                || serviceRequestReadOnlyData.sServiceCode === "LLPROCCOMPAMC" ?
                                                (
                                                    <div className="col-12 conv-mt10">

                                                        <label className="my-services-model-value">Offline Meet</label>
                                                        <Select
                                                            styles={{
                                                                width: "30%",
                                                                // Fixes the overlapping problem of the component
                                                                menu: provided => ({ ...provided, zIndex: 3 })
                                                            }}

                                                            options={props.offlinemeetPOptions}
                                                            onChange={props.setselectedofflinemeetPOptions}
                                                            value={props.selectedofflinemeetPOptions}
                                                            //value={getSelectedItem(props.offlinemeetPOptions,serviceRequestReadOnlyData.bOfflineMeet)}
                                                            className='react-select-container'
                                                            classNamePrefix="react-select"
                                                            theme={theme => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary: '#76287C',
                                                                    primary25: '#F4DFF4',
                                                                },
                                                            })}
                                                        ></Select>
                                                        {/* {<button className="sp-inline-button"
                                        onClick={props.onUpdateOfflineMeetoptions}>
                                            Save
                                        </button>} */}

                                                    </div>
                                                ) :
                                                ("")
                                        }








                                    </div>
                                </div>
                                <div className="col-12 conv-mt15">
                                    <label className="my-services-model-value">Follow Action*</label>
                                    <textarea
                                        name="sFollowupNotes"
                                        className="w-100 form-control rounded"
                                        value={serviceRequestEditableData.sFollowupNotes}
                                        onChange={({ target: { name, value } }) =>
                                            props.onInputChange(name, value)
                                        }
                                        style={{ minHeight: "80px", maxHeight: "80px" }}
                                    />
                                </div>
                                <div className="col-12 conv-mt15">
                                    <label className="my-services-model-value">Notes*</label>
                                    <textarea
                                        className="w-100 form-control rounded"
                                        name="sNotes"
                                        value={serviceRequestEditableData.sNotes}
                                        onChange={({ target: { name, value } }) =>
                                            props.onInputChange(name, value)
                                        }
                                        style={{ minHeight: "80px", maxHeight: "80px" }}
                                    />
                                </div>

                                {/* <div className="conv-ml20 conv-mt10">
                                <Checkbox
                                    label="Complete"
                                    name="bHandled"
                                    id="bHandled"
                                    value={
                                        serviceRequestEditableData
                                            ? serviceRequestEditableData.bHandled
                                            : false
                                    }
                                    checked={
                                        serviceRequestEditableData
                                            ? serviceRequestEditableData.bHandled
                                            : false
                                    }
                                    onChange={({ target: { name, checked } }) =>
                                        props.onInputChange(name, checked)
                                    }
                                ></Checkbox>
					        </div> */}




                                <div className="col-12 conv-mt15">
                                    <div className="row">
                                        <div className="col-6">
                                            {/* <div className="lpm-checkbox-label conv-pr5 conv-mr40">
                                            <Checkbox
                                                id={`Complete`}
                                                checked={props.showTatnotFollowedServiceRequests}
                                                onChange={props.toggleTatnotFollowedServiceRequests}
                                                label={"Complete"}																	
                                            ></Checkbox>
                                </div> */}
                                        </div>
                                        <div className="col-6">
                                            <span className="my-services-dnd-link con-cursor-pointer conv-float-right conv-ml25"
                                                onClick={() => { props.toggleViewAllNotesModal() }}>All Notes</span>
                                            <span className="my-services-dnd-link con-cursor-pointer conv-float-right"
                                                onClick={() => { props.toggleNotesTrailModal() }}>Trail</span>
                                        </div>
                                    </div>

                                    {/* <div className="col-4">
                                     
                                        <label className="my-services-model-value">Offline Meet</label>
                                        <Select
                                                styles={{width:"40%",
                                                // Fixes the overlapping problem of the component
                                                menu: provided => ({ ...provided, zIndex: 3 })
                                                }}                                                
                                                options={props.offlinemeetPOptions}
                                                onChange={props.setselectedofflinemeetPOptions}
                                                value={props.selectedofflinemeetPOptions}
                                                className='react-select-container'
                                                classNamePrefix="react-select"
                                                theme={theme => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary: '#76287C',
                                                        primary25: '#F4DFF4',
                                                    },
                                                    })}
                                            ></Select>
                                         
                                    </div> */}
                                </div>
                            </div>
                        </div>

                    </div>



                    <div className="row">
                        <div className="col-7 conv-mr0 my-services-model-bottom-left ">
                            <span className="my-services-dnd-link con-cursor-pointer"
                                onClick={() => {
                                    if(AppData != undefined && AppData.status === null){
                                        if(AppData.bookdate > CurrentDate || (AppData.bookdate === CurrentDate && bookTime > timeRN)){
                                            localStorage.setItem('APPID', AppData.id)
                                        }
                                    }

                                    if ((!serviceRequestReadOnlyData.bMovedToSPM) && serviceRequestReadOnlyData.refSRState != "Cancelled") {
                                        if (props.isUnsavedData) {
                                            if (props.isAllFieldsArevallid) {
                                                props.toggleUnsavedDataModal();
                                            }
                                            else {
                                                toast(`Please fill all required fields before progressing the service.`,
                                                    {
                                                        autoClose: 5000,
                                                        type: toast.TYPE.ERROR,
                                                    });
                                            }
                                        }
                                        else {
                                            props.toggleServiceProgressionModal();
                                        }
                                    }
                                    else {
                                        props.toggleServiceProgressionModal();
                                    }
                                }}>Status</span>
                            <span className="my-services-dnd-link conv-ml40 con-cursor-pointer"
                                onClick={() => { props.toggleStatusLogModal() }}>Status Log</span>
                            <span className="my-services-dnd-link conv-ml40 con-cursor-pointer"
                                onClick={() => { props.toggleSMSTrailModal() }}>SMS Trail</span>
                            <span className="my-services-dnd-link conv-ml40 con-cursor-pointer"
                                onClick={() => { props.toggleViewAllSMSModal() }}>All SMS</span>




                            {/* <button
                                style={{ width: "30px", height: "30px", marginRight: "10px", border: "none", padding: "3px" }}
                                onClick={() => getDirection("previous")}
                                className={`navBtn conv-ml50 con-cursor-pointer
                            ${props.currentServiceRequestIndex === 0 ||
                                        props.serviceRequestList[serviceRequestReadOnlyData["sEmailAddress"]].length === 1 ?
                                        "disablePrevious" : ""
                                    }`}
                            >
                                <span><ChevronLeft /></span>
                            </button>
                            <button
                                style={{ width: "30px", height: "30px", border: "none", padding: "3px" }}
                                onClick={() => getDirection("next")}
                                className={`navBtn con-cursor-pointer
                            ${props.currentServiceRequestIndex === props.serviceRequestList[serviceRequestReadOnlyData["sEmailAddress"]].length - 1 ||
                                        props.serviceRequestList[serviceRequestReadOnlyData["sEmailAddress"]].length === 1 ?
                                        "disablePrevious" : ""
                                    }`}
                            >
                                <span> <ChevronRight /></span>
                            </button> */}


                        </div>

                        <div className="col-5 my-services-model-bottom-right conv-text-center">
                            <button
                                type="button"
                                className={`my-services-model-cancel-btn conv-mr25 
                            ${serviceRequestReadOnlyData.bMovedToSPM ? "disable" : ""}
                            ${serviceRequestReadOnlyData.refSRState === "Cancelled" ? "disable" : ""}`}
                                onClick={() => props.toggleCancellationReasonModal()}>
                                Cancel Request
                            </button>
                            <button
                                type="button"
                                className={`my-services-model-submit-btn conv-pr15 conv-pl15
                             ${serviceRequestReadOnlyData.bMovedToSPM ? "disable" : ""}
                             ${serviceRequestReadOnlyData.refSRState === "Cancelled" ? "disable" : ""}`}
                                onClick={() => props.onUpdateServiceRequest()}>
                                Confirm and Save
                            </button>
                        </div>
                        {/* <div className="col-5 my-services-model-bottom-right conv-text-center">
                        <button 
                            type="button" 
                            className={"my-services-model-cancel-btn conv-mr25 "}
                             
                            onClick={() =>props.toggleCancellationReasonModal()}>
                            Cancel Request
                        </button>
                        <button 
                            type="button" 
                            className={"my-services-model-submit-btn conv-pr15 conv-pl15"}
                             
                            onClick={() =>props.onUpdateServiceRequest()}>
                            Confirm and Save
                        </button>
                    </div> */}
                    </div>
                    {
                        props.showServiceProgressionModal &&
                        (
                            <MyServiceRequestStatusProgression
                                isLoading={props.isLoading}
                                isUnsavedData={props.isUnsavedData}
                                isAllFieldsArevallid={props.isAllFieldsArevallid}
                                toggleUnsavedDataModal={props.toggleUnsavedDataModal}
                                getMyServiceRequestsForInterval={props.getMyServiceRequestsForInterval}
                                disableConfirmAndSave={
                                    serviceRequestReadOnlyData.refSRState ===
                                        "Cancelled"
                                        ? "disable"
                                        : ""
                                }
                                isMovedToSPM={props.isMovedToSPM}
                                isDisabled={
                                    serviceRequestReadOnlyData.bMovedToSPM ||
                                        serviceRequestReadOnlyData.refSRState ===
                                        "Cancelled"
                                        ? "disabled"
                                        : ""
                                }
                                serviceRequestReadOnlyData={serviceRequestReadOnlyData}
                                paymentURL={
                                    serviceRequestReadOnlyData.urlPayment
                                }
                                packageType={
                                    serviceRequestReadOnlyData.sPackageOfferPaymentType
                                }
                                nResourceInstanceId={
                                    serviceRequestReadOnlyData.nResourceInstanceId
                                }
                                paymentStatus={
                                    serviceRequestReadOnlyData.sPaymentStatus
                                }
                                paymentMode={
                                    serviceRequestReadOnlyData.sPaymentMode
                                }
                                currentState={
                                    serviceRequestReadOnlyData.refSRState
                                }
                                deliveryMode={
                                    serviceRequestReadOnlyData.sDeliveryMode
                                }
                                catalogueId={
                                    serviceRequestReadOnlyData.sCatalogueId
                                }
                                catalogueMode={props.catalogueMode}
                                recalculateURL={
                                    serviceRequestReadOnlyData.sPaymentMode ===
                                        "No_Payment" ||
                                        serviceRequestReadOnlyData.sPaymentMode ===
                                        "SP_paid_service" ||
                                        serviceRequestReadOnlyData.refSRState ===
                                        "Payment Received" ||
                                        props.catalogueMode !== "DYNAMIC"
                                        ? null
                                        : URL_CALCULATOR +
                                        String(
                                            serviceRequestReadOnlyData.nResourceInstanceId
                                        )
                                }
                                catalogueByServiceRequest={
                                    props.catalogueByServiceRequest
                                }
                                masterServiceRequestStates={
                                    props.masterServiceRequestStates
                                }
                                togglCatalogueModal={props.togglCatalogueModal}
                                toggleNeftModal={props.toggleNeftModal}
                                onSendPaymentLink={props.onSendPaymentLink}
                                onChangeState={props.onChangeState}
                                invoiceURL={
                                    serviceRequestReadOnlyData.urlInvoice
                                }
                                toggleConfirmationModal={props.toggleConfirmationModal}
                                dtCouponExpiryDate={serviceRequestReadOnlyData.dtCouponExpiryDate}
                                bCouponApplied={serviceRequestReadOnlyData.bCouponApplied}
                                showConfirmationModal={props.showConfirmationModal}
                                nPackageInstanceId={serviceRequestReadOnlyData.nPackageInstanceId}
                                toggleServiceProgressionModal={props.toggleServiceProgressionModal}
                                showServiceProgressionModal={props.showServiceProgressionModal}
                                toggleCancellationReasonModal={props.toggleCancellationReasonModal}
                            />
                        )
                    }
                    {
                        props.isCatalogueModalOpen &&
                        (
                            <SelectCatalogueModal
                                isLoading={props.isLoading}
                                isDisabled={
                                    serviceRequestReadOnlyData.bMovedToSPM
                                        ? "disable-modal"
                                        : ""
                                }
                                isOpen={props.isCatalogueModalOpen}
                                catalogue={props.catalogueByServiceRequest}
                                selectedCatalogue={props.selectedCatalogue}
                                toggleModal={props.togglCatalogueModal}
                                onCatalogueSelected={props.onCatalogueSelected}
                                onSaveCatalogue={props.onSaveCatalogue}
                            />
                        )
                    }
                    {
                        props.isNeftModalOpen &&
                        (
                            <NeftModal
                                isLoading={props.isLoading}
                                isDisabled={
                                    serviceRequestReadOnlyData.bMovedToSPM
                                        ? "disable-modal"
                                        : ""
                                }
                                isOpen={props.isNeftModalOpen}
                                toggleModal={props.toggleNeftModal}
                                neftDetails={props.neftDetails}
                                onInputChange={props.onNeftDetailsChanged}
                                onSaveNeftDetails={props.onSaveNeftDetails}
                                showSendNeftDetailsModal={props.showSendNeftDetailsModal}
                                setShowSendNeftDetailsModal={props.setShowSendNeftDetailsModal}
                                nResourceInstanceId={serviceRequestReadOnlyData.nResourceInstanceId}
                            />
                        )
                    }

                </div>

            </ModalContent>
        </Modal>
    );
}
